// utils/useWaitForPermissions.js
export function waitForPermissionsReady() {
  return new Promise((resolve) => {
    const perms = window.__permissionsCache || {};

    // Already loaded?
    if (perms && Object.keys(perms).length > 0) {
      resolve(perms);
      return;
    }

    // Wait for event
    const handler = () => {
      const latest = window.__permissionsCache || {};
      if (Object.keys(latest).length > 0) {
        window.removeEventListener("permissionsLoaded", handler);
        resolve(latest);
      }
    };

    window.addEventListener("permissionsLoaded", handler, { once: true });
  });
}

/**
 * Helper to use inside Zustand open() methods
 */
export async function waitForPermissionAndRun(callback) {
  const perms = await waitForPermissionsReady();
  callback(perms);
}
